import * as _4 from 'lodash4';
import * as moment from 'moment';
import { IAppointmentLocationsOrganizersDatasource } from '../datasources/appointment_location_staff_datasource';
import { ILocation, IOrganizer } from '../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';
import { AppointmentsCommandServant } from './appointments_command_servant';

export interface IAppointmentsAvailableTimesServant {
  location_ids: string | null;
  student_service_id: number;
  organizer_ids: string;
  week_offset?: number;
  appointment_campaign_id?: string;
}

export interface IAppointmentsAvailableTimesParams {
  appointment_type_id?: number;
  course_id?: number | null;
  student_service_id?: number;
  student_service_category_id?: number;
  organizer_ids: string;
  location_ids?: string;
  invitation_id?: number;
  start_date: number;
}

export class AppointmentsAvailableTimesServant {
  private offset: number = 0;
  constructor(
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAppointmentLocationsOrganizersDatasource: IAppointmentLocationsOrganizersDatasource,
    private ngAppointmentsCommandServant: AppointmentsCommandServant
  ) {}
  get nextWeekOffset(): number {
    return ++this.offset;
  }
  get previousWeekOffset(): number {
    return --this.offset;
  }
  clearWeekOffSet(): void {
    this.offset = 0;
  }

  requestParams(weekOffset: number, invitationId: number = 0): IAppointmentsAvailableTimesParams {
    const isCourseSelected = this.ngAppointmentReasonUsersource.read().selectedService.isCourse;
    const appointment_type_id = this.ngAppointmentReasonUsersource.read().selectedType.id;
    const student_service_id = this.ngAppointmentReasonUsersource.read().selectedService.id;
    const course_id = this.ngAppointmentsCommandServant.getCourseId();
    const student_service_category_id: number = this.ngAppointmentReasonUsersource.read().selectedCategory.id;
    const organizer_ids = this.ngAppointmentsCommandServant.selectedOrganizerIds();
    const location_ids = this.sellectedLocationIds;
    const week_offset: number = weekOffset;
    const start_date = moment().startOf('week').add(week_offset, 'week').unix();
    if (invitationId > 0) {
      return {
        invitation_id: invitationId,
        organizer_ids,
        start_date
      };
    }
    return isCourseSelected
      ? {
          appointment_type_id,
          course_id,
          student_service_category_id,
          organizer_ids,
          location_ids,
          start_date
        }
      : {
          appointment_type_id,
          course_id,
          student_service_id,
          student_service_category_id,
          organizer_ids,
          location_ids,
          start_date
        };
  }

  get sellectedLocationIds(): string {
    const selectedLocationId = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.id;
    let selectedLocationIds: string = '';
    const locationsList = this.ngAppointmentLocationsOrganizersDatasource.values();
    if (selectedLocationId < 0) {
      selectedLocationIds = _4.join(
        _4.map(locationsList, (location: ILocation) => location.id),
        ','
      );
    } else {
      selectedLocationIds = selectedLocationId.toString();
    }
    return selectedLocationIds;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointments_available_times_servant.ts